<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Organisation de l'équipe officinale - composition">
        <p class="text-sm-left body-2 font-italic">
          Les informations à renseigner ne le sont qu’à titre indicatif et ne
          sauraient préjuger de l’avis qui sera émis par la commission régionale
          d’agrément.
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="4"
              ><v-select
                v-model="dossier.nbCotitulaires"
                :items="rangeNombres"
                label="Nombre de pharmacien(s) co-titulaire(s) ou associé(s)"
                required
                :rules="selectRules"
              ></v-select
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="dossier.nbAdjoints"
                min="0"
                step=".1"
                type="number"
                label="Nombre de pharmacien(s) adjoint(s) (en équivalent temps plein)"
                required
                hint="équivalent temps plein"
                persistent-hint
                :rules="decimalRules"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="dossier.nbEtudiantsRemplacement"
                min="0"
                step=".1"
                type="number"
                label="Nombre d’étudiant(s) muni(s) d’un certificat de remplacement  (en équivalent temps plein)"
                required
                hint="équivalent temps plein"
                persistent-hint
                :rules="decimalRules"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="dossier.nbPreparateurs"
                min="0"
                step=".1"
                type="number"
                label="Nombre de préparateur(s) en pharmacie  (en équivalent temps plein)"
                required
                hint="équivalent temps plein"
                persistent-hint
                :rules="decimalRules"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="dossier.nbEtudiantsSalaries"
                min="0"
                step=".1"
                type="number"
                label="Nombre d’étudiant(s) en pharmacie salariés  (en équivalent temps plein)"
                required
                hint="équivalent temps plein"
                persistent-hint
                :rules="decimalRules"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="dossier.nbPreparateursApprentis"
                min="0"
                step=".1"
                type="number"
                label="Nombre d’apprentis préparateurs  (en équivalent temps plein)"
                required
                hint="équivalent temps plein"
                persistent-hint
                :rules="decimalRules"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field
                v-model="dossier.autresEncadrants"
                label="Autres personnes pouvant participer à l'encadrement (préciser)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn
                color="blue"
                class="mr-4 white--text"
                @click="submit"
                :disabled="!valid"
                >Enregistrer et passer à l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Partie6",
  props: ["dossier"],
  components: { BaseBlock },
  data: () => ({
    valid: true,
    rangeNombres: [...Array(20).keys()],
    textareaRules: [
      v => (v !== null && v.length <= 300) || "300 caractère max."
    ],
    selectRules: [v => parseInt(v) >= 0 || "Ce champ est requis"],
    decimalRules: [v => parseInt(v) >= 0 || "Ce champ est requis"]
  }),
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
